import { Request } from '../../../../httpClient/serverApi/requests/Request';
import { IResult } from '../../../../httpClient/serverApi/types/IResponse';

export interface AddOAuthClientParams {
    dbClass: string;
    instanceUrl: string;
    clientId: string;
    clientSecret: string;
    redirectUri: string;
    oauthConfigId?: string;
}

export interface AddOAuthClientsParams {
  oauthClients: AddOAuthClientParams[];
}

export class AddOAuthClientsRequest extends Request<AddOAuthClientsParams, IResult> {
  constructor(params: AddOAuthClientsParams) {
    super('addOAuthClients', params);
  }
}
